import { MutationTree } from "vuex";
import { IMyBookingsState } from "@/core/interfaces/state/myBookingsState.interface";
import { IMyBookingsFlight } from "@/core/interfaces/state/flightBookings.interface";
import { IMyBookingsHotel } from "@/core/interfaces/state/hotelBookings.interface";
import { IMyBookingsTour } from "@/core/interfaces/state/tourBookings.interface";

const mutations: MutationTree<IMyBookingsState> = {
  enableIsFetchFlightBookings(state) {
    state.isFetchingFlightBookings = true;
  },
  saveFlightBookings(state, payload: IMyBookingsFlight) {
    state.flightBookings = payload;
    state.isFetchingFlightBookings = false;
  },
  enableIsDownloadingBrandTicket(state) {
    state.isDownloadingBrandTicket = true;
  },
  disableIsDownloadingBrandTicket(state) {
    state.isDownloadingBrandTicket = false;
  },
  enableIsDownloadingTourVoucher(state) {
    state.isDownloadingTourVoucher = true;
  },
  disableIsDownloadingTourVoucher(state) {
    state.isDownloadingTourVoucher = false;
  },

  enableIsSendingAirlineTicket(state) {
    state.isSendingAirlineTicket = true;
  },
  disableIsSendingAirlineTicket(state) {
    state.isSendingAirlineTicket = false;
  },
  enableIsFetchHotelBookings(state) {
    state.isFetchingHotelBookings = true;
  },
  enableIsFetchTourBookings(state) {
    state.isFetchingTourBookings = true;
  },

  saveHotelBookings(state, payload: IMyBookingsHotel) {
    state.hotelBookings = payload;
    state.isFetchingHotelBookings = false;
  },
  saveTourBookings(state, payload: IMyBookingsTour) {
    state.tourBookings = payload;
    state.isFetchingTourBookings = false;
  },
  enableIsDownloadingMBHotelVoucher(state: IMyBookingsState) {
    state.isDownloadingMBHotelVoucher = true;
  },
  disableIsDownloadingMBHotelVoucher(state: IMyBookingsState) {
    state.isDownloadingMBHotelVoucher = false;
  },
  saveVoucherUrl(state, payload: string) {
    state.voucherUrl = payload;
  },
};

export default mutations;
